import { useState } from "react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import ClassEntryForm from "./ClassEntryForm";
import { EMPTY_CLASS } from "./constants";

export default function CellEditor({ entries, staffList, staffLookup, studentList, studentLookup, groupOptions, onSave, onClose, dayLabel, blockLabel, accentColor }) {
  const [classes, setClasses] = useState(
    entries.length > 0 ? entries.map(e => ({ ...EMPTY_CLASS, ...e })) : [{ ...EMPTY_CLASS }]
  );

  const handleChange = (index, updated) => setClasses(prev => prev.map((c, i) => i === index ? updated : c));
  const handleRemove = (index) => setClasses(prev => prev.filter((_, i) => i !== index));
  const handleAdd = () => setClasses(prev => [...prev, { ...EMPTY_CLASS }]);

  const handleSave = () => {
    // Keep any class that has meaningful content. Previously this dropped classes
    // that had only a group/students/location (no subject AND no lead teacher),
    // which silently deleted them on save.
    const hasContent = (c) => (
      c.subject || c.lead_staff_id ||
      (c.support_staff_ids && c.support_staff_ids.length > 0) ||
      c.student_group_key || c.student_group ||
      (c.student_ids && c.student_ids.length > 0) ||
      c.location || c.requires_signup
    );
    const filtered = classes.filter(hasContent);
    onSave(filtered);
    onClose();
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{dayLabel} - {blockLabel}</DialogTitle>
          <p className="text-sm text-muted-foreground">{classes.length} class{classes.length !== 1 ? "es" : ""} in this block</p>
        </DialogHeader>
        <div className="space-y-1">
          {classes.map((cls, i) => (
            <ClassEntryForm key={i} data={cls} index={i} staffList={staffList} staffLookup={staffLookup} studentList={studentList} studentLookup={studentLookup} groupOptions={groupOptions} onChange={(updated) => handleChange(i, updated)} onRemove={() => handleRemove(i)} color={accentColor || "#2563EB"} totalCount={classes.length} />
          ))}
          <Button variant="outline" size="sm" className="w-full mt-2 border-dashed" onClick={handleAdd} data-testid="add-class-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="mr-1"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
            Add Another Class
          </Button>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button className="bg-[#00305E] hover:bg-[#00305E]/90" onClick={handleSave} data-testid="save-cell-btn">Save</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
